import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { CurrentUserContext } from '../../context/CurrentUserContext'

const InstructorIndex = () => {
  interface CoursesProps{
    _id?: number,
    name?: string,
    description?: string,
    price?: number,
    image?: {},
    categories?: string,
    lessons:[]
    
  }
  const { currentUser } = useContext(CurrentUserContext);
  const id = currentUser?._id;
  const [courses, setCourses] = useState<CoursesProps | any>([]);
  
  useEffect(() => {
    async function fetchData() {
        const response = await fetch(`https://api-j06q.onrender.com/api/instructor/your-courses/${id}`)
        const data = await response.json();
        setCourses(data);
    }
    fetchData();
    
  }, [id])
  
  
  

  return (
      <div>
      <h1>Instructor Dashboard</h1>
      <div>
        {courses.map((course: { _id: number; name: string; description: string; price: number; image: { Location: string }; category: string; paid: string; lessons: []; slug:string },key:any) => {
                
        return (
          <div key={course._id}>
            <img src={course?.image?.Location} alt={`${course.name}`} />
            <Link to={`/instructor/courses/view/${course.slug}`}><h1>{course.name}</h1></Link>
            <div>{ course.lessons.length} Lessons</div>
          </div>
        );
      })}
      </div>
    </div>

    
  )
}

export default InstructorIndex